import { BlendMode } from '@website-builder/model/style/blend-mode';
import { TbLink } from '@website-builder/model/domain/link/tb-link';
import { makeEntityId } from '@website-builder/util/make-widget-id.utility';
import { EntityIdPrefix } from '@website-builder/model/domain/entity-id-prefix.enum';

export class GalleryElement {
  id = makeEntityId(EntityIdPrefix.WIDGET_ELEMENT);
  title = '';
  subtitle = '';
  content = '';
  src: string;
  hoverSrc: string;
  blendMode: BlendMode;
  buttonText: string;
  link = new TbLink();
  tags: string | string[] = [];

  constructor(src?: string) {
    this.src = src;
  }

  static normalizeInPlace(element: GalleryElement): GalleryElement {
    const pureElement = new GalleryElement();

    element.title = element.title ?? pureElement.title;
    element.subtitle = element.subtitle ?? pureElement.subtitle;
    element.content = element.content ?? pureElement.content;
    element.src = element.src ?? pureElement.src;
    element.hoverSrc = element.hoverSrc ?? pureElement.hoverSrc;
    element.blendMode = element.blendMode ?? pureElement.blendMode;
    element.buttonText = element.buttonText ?? pureElement.buttonText;
    element.link = TbLink.normalizeInPlace(element.link ?? pureElement.link);
    element.tags = element.tags ?? pureElement.tags;

    return element;
  }
}
